import { CSSProperties, useEffect, useMemo, useState } from "react";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import { Progress } from "antd";
import { handleDownload } from "@lhd/features/Apps/utils";
interface Iprops {
  url: string;
  isDisabled?: boolean;
  isUploading?: boolean;
  widthIcon?: number;
  style?: CSSProperties;
}
const IconDownload = ({
  url,
  isUploading,
  isDisabled,
  widthIcon = 15,
  style,
}: Iprops) => {
  const [downloadState, setDownloadState] = useState<{
    status: "exception" | undefined;
    percent: number;
    isLoading: boolean;
  }>();
  const controller = useMemo(() => new AbortController(), []);
  useEffect(() => () => controller.abort(), []);
  const disable = isUploading || isDisabled || downloadState?.isLoading;
  return (
    <div
      style={{ ...style }}
      onClick={() => {
        if (disable) return;
        handleDownload(url, controller, setDownloadState);
      }}
    >
      {downloadState?.isLoading ? (
        <Progress
          type="circle"
          percent={downloadState.percent}
          status={downloadState.status}
          width={widthIcon}
        />
      ) : downloadState?.status === "exception" ? (
        <ReloadOutlined
          style={{
            opacity: disable ? 0.5 : 1,
            cursor: disable ? "not-allowed" : "pointer",
            color: "red",
          }}
          width={widthIcon}
        />
      ) : (
        <DownloadOutlined
          style={{
            opacity: disable ? 0.5 : 1,
            cursor: disable ? "not-allowed" : "pointer",
          }}
          width={widthIcon}
        />
      )}
    </div>
  );
};
export default IconDownload;
